// import { Injectable } from '@angular/core';
// import { BehaviorSubject } from 'node_modules/rxjs';

// @Injectable()
// export class MessageService {
//     private messageSource = new BehaviorSubject('');
//     currentMessage = this.messageSource.asObservable();

//     constructor() { }

//     changeMessage(message: string) {
//       this.messageSource.next(message);
//     }
// }
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'node_modules/rxjs';
import { HttpErrorResponse } from '@angular/common/http';

@Injectable({ providedIn: 'root' })
export class MessageService {
    private subject = new Subject<any>();

    sendMessage(message: string) {
        this.subject.next({ text: message });
    }

    sendErrorMessage(error: any) {
        if (error instanceof HttpErrorResponse) {
            if (error.error.errors) {
              const errorDetailsList = error.error.errors;
              let errorText = '';
              Object.keys(errorDetailsList).forEach(key => {
                const val = errorDetailsList[key];
                if (val.length > 0) {
                  errorText += `<div>${val[0].toString()}</div>`;
                }
              });
              this.sendMessage(errorText);

            } else if (error.error) {
              this.sendMessage(error.error);
            }
          } else {
            this.sendMessage(error.error);
          }
    }

    clearMessage() {
        this.subject.next(true);
    }

    getMessage(): Observable<any> {
        return this.subject.asObservable();
    }
}